<template>
    <section class="content">
        <div class="row">
            <div class="col-md-12">
                <div class="box box-primary">
                    <div class="box-header with-border">
                        <h3 class="box-title">
                            <b>Verificação de atendimentos</b>
                        </h3>
                    </div>
                    <div class="box-body">
                        <form @submit.prevent="getDataTable()">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for>Paciente</label>
                                        <select-paciente
                                            @setPacienteSelecionado="
                                                paciente => {
                                                    setPacienteSelecionado(paciente);
                                                }
                                            "
                                        ></select-paciente>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="form-group">
                                        <label for>Código da solicitação</label>
                                        <input v-model="filtros.codigo" class="form-control" type="text" />
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="form-group">
                                        <label for>Solicitado de</label>
                                        <input v-model="filtros.dataInicial" class="form-control" type="date" />
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="form-group">
                                        <label for>Até</label>
                                        <input v-model="filtros.dataFinal" class="form-control" type="date" />
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label for>Situação da solicitação</label>
                                        <select v-model="filtros.situacao" class="form-control">
                                            <option value>Todas</option>
                                            <option :value="SITUACAO_SOLICITACAO.MARCADA">Marcada</option>
                                            <option :value="SITUACAO_SOLICITACAO.EM_REGULACAO">Em regulação</option>
                                            <option :value="SITUACAO_SOLICITACAO.REGULADA">Regulada</option>
                                            <option :value="SITUACAO_SOLICITACAO.INFORMACAO_PENDENTE">Informação pendente</option>
                                            <option :value="SITUACAO_SOLICITACAO.INFORMACAO_ADICIONAL">Informação adicional</option>
                                            <option :value="SITUACAO_SOLICITACAO.NEGATIVADA">Negativada</option>
                                            <option :value="SITUACAO_SOLICITACAO.CONFIRMADA">Confirmada</option>
                                            <option :value="SITUACAO_SOLICITACAO.CANCELADA">Cancelada</option>
                                            <option :value="SITUACAO_SOLICITACAO.FALTA">Falta</option>
                                            <option :value="SITUACAO_SOLICITACAO.REALIZADA">Realizada</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for>Unidade solicitante</label>
                                        <select-unidade
                                            @setUnidadeSelecionada="
                                                unidadeSelecionada => {
                                                    setUnidadeSelecionada(unidadeSelecionada);
                                                }
                                            "
                                        ></select-unidade>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="form-group">
                                        <label for>Regulado dia:</label>
                                        <input v-model="filtros.dataRegulacao" class="form-control" type="date" />
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label for>Profissional solicitante</label>
                                        <select-profissional
                                            tipo-profissional="Solicitante"
                                            @setProfissionalSolicitanteSelecionado="
                                                profissional => {
                                                    setProfissionalSolicitanteSelecionado(profissional);
                                                }
                                            "
                                        ></select-profissional>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label for>Usuario marcador</label>
                                        <select-usuario
                                            nivel="marcador"
                                            @setUsuarioSelecionado="
                                                usuario => {
                                                    setUsuarioSelecionado(usuario);
                                                }
                                            "
                                        ></select-usuario>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label for>Profissional realizador</label>
                                        <select-profissional
                                            tipo-profissional="Realizador"
                                            @setProfissionalRealizadorSelecionado="
                                                profissional => {
                                                    setProfissionalRealizadorSelecionado(profissional);
                                                }
                                            "
                                        ></select-profissional>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <button class="btn btn-primary pull-right"><span class="fa fa-search"></span> Pesquisar</button>
                                </div>
                            </div>
                        </form>
                        <br />
                        <table class="table table-bordered table-striped table-hover">
                            <thead>
                                <tr>
                                    <th>Código da solicitação</th>
                                    <th>Tipo Atendimento</th>
                                    <th>Tipo Consulta</th>
                                    <th>Data da solicitação</th>
                                    <th>Procedimento</th>
                                    <th>Paciente</th>
                                    <th>Sexo</th>
                                    <th>Solicitante</th>
                                    <th>Realizador</th>
                                    <th>Data da realização</th>
                                    <th>Marcador</th>
									<th>Competência</th>
                                    <th style="width: 12%">Situação</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr @click="detalheSolicitacao(item)" class="hand" v-for="(item, index) in dataTable.data" :key="index">
                                    <td width="7%">{{ item.id | formatarCodigo }}</td>
                                    <td width="7%">{{ item.tipo_atendimento | tipoAtendimento }}</td>
                                    <td>{{ item.itens[0].tipo_consulta | tipoConsulta }}</td>
                                    <td>{{ item.created_at | dataHoraFormatada }}</td>
                                     <td>{{ item.itens[0].contrato_procedimento.procedimento.nome }}</td>
                                    <td>{{ item.paciente.nome }}</td>
                                    <td>{{ item.paciente.sexo | sexo }}</td>
                                    <td>{{ item.profissional.nome }}</td>
                                    <td v-if="item.itens[0].contrato_procedimento_atendimento">{{item.itens[0].contrato_procedimento_atendimento.profissional.nome }}</td>
                                    <td v-else>SEM PROFISSIONAL</td>
                                    <td v-if="item.itens[0].contrato_procedimento_atendimento || item.itens[0].contrato_subgrupo_atendimento">{{item.itens[0].contrato_procedimento_atendimento ? item.itens[0].contrato_procedimento_atendimento.data_atendimento : item.itens[0].contrato_subgrupo_atendimento.data_atendimento | dataFormatada }} a partir das {{item.itens[0].contrato_procedimento_atendimento ? item.itens[0].contrato_procedimento_atendimento.hora_inicial : item.itens[0].contrato_subgrupo_atendimento.hora_inicial}}</td>
									<td v-else>SEM DATA DEFINIDA</td>
									<td>{{ item.usuario.name }}</td>
									<td>{{ item.itens[0].contrato_procedimento.contrato.distribuicao.data_competencia | mesPorExtenso }}</td>
                                    <td>
                                        <strong :class="item.situacao | situacaoSolicitacaoColor">{{ verificarCancelamento(item) }}</strong>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="row">
                            <div class="col-sm-5">Mostrando {{ this.dataTable.from }} até {{ this.dataTable.to }} de {{ this.dataTable.total }} registros encontrados.</div>
                            <div class="col-sm-7" style="text-align:right">
                                <laravue-pagination :limit="5" :data="dataTable" v-on:pagination-change-page="getDataTable">
                                    <span slot="prev-nav">&lt; Anterior</span>
                                    <span slot="next-nav">Próximo &gt;</span>
                                </laravue-pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <modal-detalhes-solicitacao :solicitacao="solicitacao" :show="showModalDetalhesSolicitacao" @close="showModalDetalhesSolicitacao = false"></modal-detalhes-solicitacao>
    </section>
</template>

<script>
import axios from "axios"; // Cliente para requisição http
import selectPaciente from "../../cadastros/pacientes/selectPaciente";
import selectProfissional from "../../cadastros/profissionais/selectProfissional";
import selectUnidade from "../../cadastros/unidades/selectUnidade";
import selectUsuario from "../../cadastros/usuarios/selectUsuario";
import modalDetalhesSolicitacao from "./modalDetalhesSolicitacao";
import { SITUACAO_SOLICITACAO } from "@/constants";
export default {
    computed: {
        SITUACAO_SOLICITACAO: function() {
            return SITUACAO_SOLICITACAO;
        }
    },
    data: () => ({
        showModalDetalhesSolicitacao: false,
        solicitacao: {
            created_at: "",
            id: "",
            itens: [
                {
                    contrato_procedimento: {
                        contrato: {
                            unidade: {
                                nome: ""
                            }
                        },
                        procedimento: {
                            nome: ""
                        }
                    },
                    contrato_procedimento_atendimento: {
                        profissional: {
                            nome: ""
                        },
                        contrato_procedimento: {}
                    }
                }
            ],
            paciente: {
                nome: "",
                cidade: {
                    nome: ""
                }
            },
            paciente_id: "",
            profissional: "",
            profissional_solicitante_id: "",
            situacao: "",
            solicitacao_historicos: [],
            diagnosticos: [],
            updated_at: "",
            usuario: "",
            usuario_solicitante_id: ""
        },
        dataTable: {},
        filtros: {
            pacienteId: "", // foi
            codigo: "", // foi
            dataInicial: "", // foi
            dataFinal: "", // foi
            unidadeId: "", // foi
            situacao: "", // foi
            dataRegulacao: "", // foi
            profissionalSolicitanteId: "", // foi
            usuarioSolicitanteId: "", // foi
            profissionalRealizadorId: "" // foi
        }
    }),
    mounted() {
        // this.getDataTable();
    },
    methods: {
        situacaoSolicitacao(value) {
            switch (value) {
                case SITUACAO_SOLICITACAO.MARCADA:
                    return "Marcada";
                case SITUACAO_SOLICITACAO.EM_REGULACAO:
                    return "Em regulação";
                case SITUACAO_SOLICITACAO.REGULADA:
                    return "Regulada";
                case SITUACAO_SOLICITACAO.INFORMACAO_PENDENTE:
                    return "Informação pendente";
                case SITUACAO_SOLICITACAO.INFORMACAO_ADICIONAL:
                    return "Informação adicional";
                case SITUACAO_SOLICITACAO.CONFIRMADA:
                    return "Confirmada";
                case SITUACAO_SOLICITACAO.CANCELADA:
                    return "Cancelada";
                case SITUACAO_SOLICITACAO.FALTA:
                    return "Falta";
                case SITUACAO_SOLICITACAO.REALIZADA:
                    return "Realizada";
                case SITUACAO_SOLICITACAO.NEGATIVADA:
                    return "Negativada";
            }
        },
        detalheSolicitacao(solicitacao) {
            this.solicitacao = solicitacao;
            this.showModalDetalhesSolicitacao = true;
        },
        verificarCancelamento(solicitacao) {
            let text = this.situacaoSolicitacao(solicitacao.situacao);
            solicitacao.solicitacao_historicos.forEach(element => {
                if (element.situacao == this.SITUACAO_SOLICITACAO.CANCELADA) {
                    text = "Cancelada por " + element.usuario.name;
                }
            });

            return text;
        },
        getDataTable(page) {
            if (typeof page === "undefined") {
                page = 1;
            }

            this.filtros.page = page;
            this.$store.commit("TOGGLE_LOADING");

            let config = this.$store.getters.getHeaderAuth;
            config.params = this.filtros;

            axios
                .get(`${this.$store.state.serverURI}/api/atendimentos/getAllPaginate`, config)
                .then(response => {
                    this.dataTable = response.data;
                    this.$store.commit("TOGGLE_LOADING");
                })
                .catch(error => {
                    console.log(error);
                });
        },
        setPacienteSelecionado(paciente) {
            this.filtros.pacienteId = paciente.id;
        },
        setUnidadeSelecionada(unidade) {
            this.filtros.unidadeId = unidade.id;
        },
        setProfissionalSolicitanteSelecionado(profissional) {
            this.filtros.profissionalSolicitanteId = profissional.id;
        },
        setUsuarioSelecionado(usuario) {
            this.filtros.usuarioSolicitanteId = usuario.id;
        },
        setProfissionalRealizadorSelecionado(profissional) {
            this.filtros.profissionalRealizadorId = profissional.id;
        }
    },
    watch: {},
    components: {
        selectPaciente,
        selectProfissional,
        selectUnidade,
        selectUsuario,
        modalDetalhesSolicitacao
    }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// index.vue?ba7ae3fe